import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetMainServices =
  ({ callback, rowsPerPage, page }) =>
  async (dispatch, getState) => {
    try {
      let link =
        UrlApi.main_services.get + `?page=${page}&limit=${rowsPerPage}`;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteMainServices =
  ({ id, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.main_services.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${id}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageMainServices =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
      }
      if (CheckDataIfExit(values?.name)) {
        bodyFormData.append("name", values?.name?.trim());
      }
      if (CheckDataIfExit(values?.title)) {
        bodyFormData.append("title", values?.title?.trim());
      }
      if (CheckDataIfExit(values?.banner_description)) {
        bodyFormData.append(
          "banner_description",
          values?.banner_description?.trim()
        );
      }
      if (CheckDataIfExit(values?.description)) {
        bodyFormData.append("description", values?.description?.trim());
      }
      if (
        values?.image &&
        values?.image != null &&
        values?.image != undefined &&
        CheckImageIsFile({ data: values?.image, IsBoolean: true })
      ) {
        bodyFormData.append("image", values?.image);
      } else if (editMode && !values?.image) {
        bodyFormData.append("image", "");
      }
      if (
        values?.banner_image &&
        values?.banner_image != null &&
        values?.banner_image != undefined &&
        CheckImageIsFile({ data: values?.banner_image, IsBoolean: true })
      ) {
        bodyFormData.append("banner_image", values?.banner_image);
      } else if (editMode && !values?.banner_image) {
        bodyFormData.append("banner_image", "");
      }

      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? `${UrlApi.main_services.edit}/${paramID}`
          : UrlApi.main_services.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });

      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditMainServices =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.main_services.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
